module.exports = __webpack_public_path__ + "static/media/tourandcruises.06ca8576.png";